import React from 'react';
import { Upload, BarChart3, Eye, Brain, Aperture, Settings } from 'lucide-react';
import NavItem from './NavItem';
import './Sidebar.css';

const Sidebar = ({ sidebarOpen, currentPage, setCurrentPage }) => {
  return (
    <div className={`sidebar-container ${sidebarOpen ? 'open' : 'closed'}`}>
      <div className="sidebar-content">
        <NavItem
          icon={<Upload size={20} />}
          text="Data Upload"
          active={currentPage === 'dataUpload'}
          onClick={() => setCurrentPage('dataUpload')}
        />
        <NavItem
          icon={<Settings size={20} />}
          text="Preprocessing"
          active={currentPage === 'preprocessing'}
          onClick={() => setCurrentPage('preprocessing')}
        />
        <NavItem
          icon={<Eye size={20} />}
          text="ExploratoryAnalysis"
          active={currentPage === 'ExploratoryAnalysis'}
          onClick={() => setCurrentPage('ExploratoryAnalysis')}
        />
        <NavItem
          icon={<BarChart3 size={20} />}
          text="Analysis"
          active={currentPage === 'analysis'}
          onClick={() => setCurrentPage('analysis')}
        />
        <NavItem
          icon={<Brain size={20} />}
          text="Differential Analysis"
          active={currentPage === 'DifferentialAnalysis'}
          onClick={() => setCurrentPage('DifferentialAnalysis')}
        />

        
        <NavItem
        icon={<Aperture size={20} />}
        text="Functional Analysis"
        active={currentPage === 'FunctionalAnalysis'}
        onClick={() => setCurrentPage('FunctionalAnalysis')}
        />

        <NavItem
          icon={<Eye size={20} />}
          text="Results"
          active={currentPage === 'results'}
          onClick={() => setCurrentPage('results')}
        />

      </div>
    </div>
  );
};

export default Sidebar;